import dayjs from 'dayjs';

export const getDateTime = () => {
    return dayjs().format('DD/MM/YYYY HH:mm');
};

export const getParamsFromUrl = () => {
    var url = window.location.search.substring(1);
    var qArray = url.split('&');
    window.parameters = {};
    qArray.forEach((item) => {
        var pArr = item.split('=');
        var key = pArr[0];
        var value = pArr[1];
        window.parameters[[key]] = value;
    });
};

export const toFirstUpperCase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
